import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesSharing } from "../../constants";
import { UpdateSharingSchedulesSettingsBody } from "./updateSharingSchedulesSettings.types";

export const requestUpdateSharingSchedulesSettings = async (
  body: UpdateSharingSchedulesSettingsBody
): Promise<void> => {
  return await instance.patch(
    buildUrl(ApiRoutesSharing.SharingSchedulesSettings),
    body
  );
};
